/**
 * /hypnose/spirituelle
 * Mot-clé cible : "hypnose spirituelle Paris", "hypnose spirituelle Pantin".
 */
import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../../components/Layout";
import { PageHero, ProseSection, BulletList, EndCTA } from "../../components/PageParts";

const EXPLORATIONS = [
  "Retrouver un sentiment de cohérence intérieure",
  "Explorer une période de questionnement, de transition ou d'éveil",
  "Se projeter dans un futur aligné",
  "Accueillir et intégrer des mémoires qui pèsent, à travers l'approche régressive",
  "Redonner de la place à l'intuition et au discernement personnels",
];

export default function Spirituelle() {
  const BREADCRUMB = [
    { to: "/", label: "Accueil" },
    { to: "/hypnose", label: "L'Hypnose" },
    { label: "Hypnose spirituelle" },
  ];
  return (
    <>
      <Seo
        title="Hypnose spirituelle à Pantin"
        description="Séance d'hypnose spirituelle à Pantin (15 min de Paris) ou en ligne. Un espace d'exploration profond pour donner du sens, se projeter, et intégrer ce qui appelle à être vu. 120 €."
        canonical="https://www.parfaitsimparfaits.fr/hypnose/spirituelle"
      />

      <PageHero
        breadcrumb={BREADCRUMB}
        eyebrow="Approche"
        title="Hypnose spirituelle"
        italic="à Pantin & en ligne"
        subtitle="Un espace d'exploration plus vaste, pour celles et ceux qui traversent un moment de sens, de transition ou d'éveil intérieur."
      />

      <ProseSection>
        <h2 className="font-serif text-3xl text-sand-900 !mt-0">Une exploration au-delà du symptôme</h2>
        <p>
          Là où l'hypnose ericksonienne cible un objectif précis, l'hypnose spirituelle ouvre un espace
          plus large. Elle ne se pense pas comme une technique appliquée à un problème, mais comme une
          <strong className="text-sand-900 font-medium"> traversée intérieure guidée </strong> qui invite
          à ralentir, écouter, et laisser émerger ce qui, en vous, appelle à être vu.
        </p>
        <p>
          Elle s'adresse aux personnes qui ressentent que quelque chose bouge, sans encore savoir quoi&nbsp;;
          qui traversent une transition importante&nbsp;; ou qui souhaitent, dans un cadre sûr, questionner
          leur trajectoire et retrouver un sentiment d'unité intérieure.
        </p>

        <h2 className="font-serif text-3xl text-sand-900">Ce que la séance permet d'explorer</h2>
        <BulletList items={EXPLORATIONS} testid="spirituelle-explorations" />
        <p>
          Je pratique une approche <strong className="text-sand-900 font-medium">sobre, respectueuse et
          orientée vers le discernement</strong>. Il ne s'agit ni de croyances imposées ni de promesses
          sensationnalistes&nbsp;: chaque personne repart avec ce qui lui parle et ce qui lui est utile,
          rien d'autre.
        </p>

        <h2 className="font-serif text-3xl text-sand-900">Régressive & projection future</h2>
        <p>
          Deux outils peuvent s'intégrer naturellement à une séance d'hypnose spirituelle. L'
          <Link to="/hypnose/regressive" className="text-[#B07A45] underline hover:text-sand-900">
            approche régressive
          </Link>{" "}
          invite à revisiter certaines mémoires pour les accueillir et les intégrer. La{" "}
          <strong className="text-sand-900 font-medium">projection future</strong>, à l'inverse,
          projette dans un futur possible aligné, comme boussole intérieure. Ces outils s'utilisent avec
          mesure, en fonction de votre demande.
        </p>

        <h2 className="font-serif text-3xl text-sand-900">Déroulement et durée</h2>
        <p>
          Comptez <strong className="text-sand-900 font-medium">environ 2h</strong>&nbsp;: un temps d'échange
          approfondi, une hypnose plus longue, puis une intégration.
        </p>
        <p>
          Ce type d'accompagnement demande souvent <strong className="text-sand-900 font-medium">plusieurs
          séances</strong> pour laisser à ce travail intérieur le temps de se déployer — à raison d'
          <strong className="text-sand-900 font-medium">une séance par mois</strong> environ, afin de
          respecter votre rythme et l'intégration entre chaque séance.
        </p>

        <h2 className="font-serif text-3xl text-sand-900">Tarif et modalités</h2>
        <p>
          <strong className="text-sand-900 font-medium">120 € la séance</strong>, à Pantin
          (Métro Église de Pantin, ligne 5, 15 min de Paris) ou en ligne, en visio.
        </p>

        <p className="!mt-10">
          <Link to="/hypnose/ericksonienne" className="text-[#B07A45] underline hover:text-sand-900">
            Comparer avec l'hypnose ericksonienne
          </Link>
          {" · "}
          <Link to="/pourquoi-consulter" className="text-[#B07A45] underline hover:text-sand-900">
            Pourquoi consulter&nbsp;?
          </Link>
        </p>
      </ProseSection>

      <EndCTA
        title="Écouter, comprendre, avancer."
        text="Un premier échange téléphonique gratuit permet de vérifier que l'approche vous convient."
        testid="spir-end-cta"
      />
    </>
  );
}
